import * as React from 'react';

const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9498 5.63599L18.364 7.0502L13.414 12L18.364 16.9497L16.9498 18.3639L12 13.414L7.05026 18.3639L5.63605 16.9497L10.586 12L5.63605 7.0502L7.05026 5.63599L12 10.586L16.9498 5.63599Z", fill: "currentColor" }));

export { SvgClose as default };
